import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbDateNLParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return {year: toInteger(dateParts[0]), month: null, day: null};
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return {year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null};
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return {year: toInteger(dateParts[2]), month: toInteger(dateParts[1]), day: toInteger(dateParts[0])};
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    let stringDate: string = '';
    if (date) {
      stringDate += isNumber(date.day) ? padNumber(date.day) + ' ' : '';
      // stringDate += isNumber(searchGroupDate.month) ? padNumber(searchGroupDate.month) + '/' : '';

      const month = new Array();
      month[0] = 'januari';
      month[1] = 'februari';
      month[2] = 'maart';
      month[3] = 'april';
      month[4] = 'mei';
      month[5] = 'juni';
      month[6] = 'juli';
      month[7] = 'augustus';
      month[8] = 'september';
      month[9] = 'oktober';
      month[10] = 'november';
      month[11] = 'december';

      stringDate += month[date.month - 1] + ' ';
      stringDate += date.year;
    }
    return stringDate;
  }
}
